var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSundail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174.081,
    height: 41.91,
    viewBox: "0 0 174.081 41.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sundial",
    transform: "translate(-425.861 -411.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M12.1-66.275c4.787,0,8.529-2.5,8.529-6.69,0-3.044-1.744-4.787-5.992-6.151l-3.329-1.11c-1.585-.507-2.949-1.141-2.949-2.758,0-1.522,1.427-2.568,3.456-2.568a4.925,4.925,0,0,1,4.5,2.758L19.772-84.6a8.727,8.727,0,0,0-8.021-4.47c-4.153,0-7.673,2.441-7.673,6.4,0,3.519,2.536,5.136,5.834,6.214l3.2,1.015c2.219.729,3.139,1.4,3.139,2.632,0,1.585-1.4,2.822-4.248,2.822a5.855,5.855,0,0,1-5.675-3.424L3-71.507C4.458-68.209,8.041-66.275,12.1-66.275Zm18.865,0c4.5,0,7.768-2.568,7.768-7.2V-82.73h-4.09v8.909c0,2.473-1.3,3.836-3.614,3.836-2.346,0-3.678-1.3-3.678-3.868V-82.73H23.26v9.258C23.26-68.875,26.367-66.275,30.964-66.275ZM52.111-83.206a5.939,5.939,0,0,0-5.295,2.536V-82.73H42.695v15.979h4.122v-8.307c0-2.695,1.49-4.47,3.995-4.47,2.219,0,3.551,1.427,3.551,3.836v8.941h4.09v-9.765C58.452-80.511,56.233-83.206,52.111-83.206Zm22.7,2.758a6.268,6.268,0,0,0-5.263-2.758c-4.724,0-8.148,3.773-8.148,8.56a8.033,8.033,0,0,0,8.021,8.37A6.621,6.621,0,0,0,74.812-69v2.251h3.931v-22.32H74.812ZM70.151-69.985a4.607,4.607,0,0,1-4.724-4.756A4.633,4.633,0,0,1,70.183-79.5a4.727,4.727,0,0,1,4.756,4.756A4.716,4.716,0,0,1,70.151-69.985ZM84.958-85.172a2.837,2.837,0,0,0,2.822-2.758,2.842,2.842,0,0,0-2.822-2.79,2.793,2.793,0,0,0-2.79,2.79A2.767,2.767,0,0,0,84.958-85.172ZM87.05-66.751V-82.73H82.929v15.979Zm16.582-13.633a6.235,6.235,0,0,0-5.295-2.822c-4.756,0-8.18,3.773-8.18,8.56a8.059,8.059,0,0,0,8.053,8.37,6.569,6.569,0,0,0,5.39-2.758v2.283h3.931V-83.586Zm-4.692,10.4a4.607,4.607,0,0,1-4.724-4.756A4.633,4.633,0,0,1,98.971-79.5a4.727,4.727,0,0,1,4.756,4.756A4.716,4.716,0,0,1,98.94-69.985Zm16.867,3.234v-22.32h-4.122v22.32Z",
    transform: "translate(484.135 511.458)",
    fill: "#1d0b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_Option_1",
    "data-name": "Logo Option 1",
    transform: "translate(425.81 412.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "round_1",
    "data-name": "round 1",
    d: "M26.563,0c14.67,0,26.563,7.661,26.563,17.111S41.234,34.222,26.563,34.222,0,26.562,0,17.111,11.893,0,26.563,0Z",
    transform: "translate(0.05 7.327)",
    fill: "#2b1258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_480",
    "data-name": "Union 480",
    d: "M0,23.641C0,15.681,8.179,8.972,19.333,6.925L18.859.664,20.16,0,21.2.878l2.441,5.5c.937-.066,1.89-.1,2.854-.1,14.636,0,26.5,7.772,26.5,17.359S41.136,41,26.5,41,0,33.228,0,23.641Z",
    transform: "translate(0.197 -0.361)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_193",
    "data-name": "Subtraction 193",
    d: "M20.5,14a29.24,29.24,0,0,1-7.979-1.08,24.986,24.986,0,0,1-3.482-1.267A21.076,21.076,0,0,1,6,9.974,16.978,16.978,0,0,1,3.5,7.939,13.334,13.334,0,0,1,1.611,5.6,10.71,10.71,0,0,1,.416,3.024,9.487,9.487,0,0,1,0,.253C0,.169,0,.084,0,0,.1,3.619,2.276,7.01,6.128,9.55A26.349,26.349,0,0,0,20.5,13.494,26.349,26.349,0,0,0,34.872,9.55C38.724,7.011,40.9,3.619,41,0c0,.089,0,.174,0,.253a9.487,9.487,0,0,1-.416,2.77A10.71,10.71,0,0,1,39.389,5.6,13.333,13.333,0,0,1,37.5,7.939,16.978,16.978,0,0,1,35,9.974a21.076,21.076,0,0,1-3.034,1.679,24.985,24.985,0,0,1-3.482,1.267A29.24,29.24,0,0,1,20.5,14Z",
    transform: "translate(7.197 23.639)",
    fill: "#2b1258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M0-1l1.048.865L12.711,25.726,0,16.6Z",
    transform: "translate(18.954 1.482)",
    fill: "#08041e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13560",
    "data-name": "Path 13560",
    d: "M-58.62,3.836-40.1,0l12.71,9.119Z",
    transform: "translate(59.058 18.082)",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundail);
export default __webpack_public_path__ + "static/media/Sundail.0a300711c5e1114c3e425d3cb8d51ab6.svg";
export { ForwardRef as ReactComponent };